export default [

    {
        key: 'photo',
        label: 'Foto'
    },
    {
        key: 'name',
        label: 'Nombre'
    },
    {
        key: 'document',
        label: 'Documento'
    },
    {
        key: 'email',
        label: 'E-mail'
    },
    {
        key: 'phone',
        label: 'Teléfono'
    },
    {
        key: 'birth_date',
        label: 'Fecha de nacimiento'
    },
    {
        key: 'genre',
        label: 'Género'
    },
    {
        key: 'client.name',
        label: 'Cliente'
    },
    {
        key: 'notes',
        label: 'Notas'
    },
    {
        key: 'actions',
        label: 'Acciones'
    },
];
